import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';
import { getSpecialsList } from '@/utils/nav';

export default function Footer() {
  const specials = getSpecialsList().slice(0, 4);
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-primary-950 text-primary-100">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-xl" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">51吃瓜网</span>
            </div>
            <p className="text-sm text-primary-200/90 leading-relaxed">
              {siteInfo.slogan}。聚焦娱乐热点、爆料与网络趣闻，实时更新，随时可看。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-900 hover:bg-primary-800 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line" />
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-900 hover:bg-primary-800 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line" />
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-900 hover:bg-primary-800 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line" />
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/category/hot-news" className="text-primary-200 hover:text-background-50 transition-colors">热点新闻</Link></li>
              <li><Link to="/category/expose" className="text-primary-200 hover:text-background-50 transition-colors">爆料报道</Link></li>
              <li><Link to="/category/web-fun" className="text-primary-200 hover:text-background-50 transition-colors">网络趣闻</Link></li>
              <li><Link to="/search" className="text-primary-200 hover:text-background-50 transition-colors">全站搜索</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">热门专题</h4>
            <ul className="space-y-2.5 text-sm">
              {specials.map((sp) => (
                <li key={sp.id}>
                  <Link to={`/special/${sp.id}`} className="text-primary-200 hover:text-background-50 transition-colors">
                    {sp.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-primary-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line" />
                <span>{siteInfo.contact.email}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-weibo-line" />
                <span>{siteInfo.contact.weibo}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line" />
                <span>{siteInfo.contact.wechat}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-information-line" />
                <Link to="/about" className="hover:text-background-50 transition-colors">关于我们</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-900/60">
        <div className="w-full px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-primary-300/80">
          <p>© {year} {siteInfo.name} · 本站为资讯演示平台，内容仅供参考</p>
          <p>适度吃瓜，理性上网</p>
        </div>
      </div>
    </footer>
  );
}